/* eslint-disable no-unused-vars */
// // 让本机浏览器打印(更优先一点)：
// oscript = document.createElement('script')
// oscript.src = 'http://localhost:8000/CLodopfuncs.js?priority=2'
// var head = document.head || document.getElementsByTagName('head')[0] || document.documentElement
// head.insertBefore(oscript, head.firstChild)
// // 引用双端口(8000和18000）避免其中某个被占用：
// oscript = document.createElement('script')
// oscript.src = 'http://localhost:18000/CLodopfuncs.js?priority=1'
// var head = document.head || document.getElementsByTagName('head')[0] || document.documentElement
// head.insertBefore(oscript, head.firstChild)
import { Message, MessageBox } from 'element-ui'
// ==本JS是加载Lodop插件及CLodop服务的综合示例，可直接使用，建议看懂后融进自己页面程序==

let CreatedOKLodopObject, CLodopIsLocal, CLodopJsState

// ==判断是否需要CLodop(那些不支持插件的浏览器):==
function needCLodop() {
  try {
    const ua = navigator.userAgent
    if (ua.match(/Windows\sPhone/i)) { return true }
    if (ua.match(/iPhone|iPod|iPad/i)) { return true }
    if (ua.match(/Android/i)) { return true }
    if (ua.match(/Edge\D?\d+/i)) { return true }

    const verTrident = ua.match(/Trident\D?\d+/i)
    const verIE = ua.match(/MSIE\D?\d+/i)
    let verOPR = ua.match(/OPR\D?\d+/i)
    let verFF = ua.match(/Firefox\D?\d+/i)
    const x64 = ua.match(/x64/i)
    if ((!verTrident) && (!verIE) && (x64)) { return true } else if (verFF) {
      verFF = verFF[0].match(/\d+/)
      if ((verFF[0] >= 41) || (x64)) { return true }
    } else if (verOPR) {
      verOPR = verOPR[0].match(/\d+/)
      if (verOPR[0] >= 32) { return true }
    } else if ((!verTrident) && (!verIE)) {
      let verChrome = ua.match(/Chrome\D?\d+/i)
      if (verChrome) {
        verChrome = verChrome[0].match(/\d+/)
        if (verChrome[0] >= 41) { return true }
      }
    }
    return false
  } catch (err) {
    return true
  }
}

// ==加载引用CLodop的主JS,用双端口8000和18000(以防其中一个被占):==
function loadCLodop() {
  if (CLodopJsState === 'loading' || CLodopJsState === 'complete') return
  CLodopJsState = 'loading'
  const head = document.head || document.getElementsByTagName('head')[0] || document.documentElement
  const JS1 = document.createElement('script')
  const JS2 = document.createElement('script')
  JS1.src = 'http://localhost:8000/CLodopfuncs.js?priority=1'
  JS2.src = 'http://localhost:18000/CLodopfuncs.js'
  JS1.onload = JS2.onload = function() { CLodopJsState = 'complete' }
  JS1.onerror = JS2.onerror = function(evt) { CLodopJsState = 'complete' }
  head.insertBefore(JS1, head.firstChild)
  head.insertBefore(JS2, head.firstChild)
  const JS3 = document.createElement('script')
  const JS4 = document.createElement('script')
  JS3.src = 'https://localhost.lodop.net:8443/CLodopfuncs.js'
  JS4.src = 'https://localhost.lodop.net:8444/CLodopfuncs.js'
  JS3.onload = JS4.onload = function() { CLodopJsState = 'complete' }
  JS3.onerror = JS4.onerror = function(evt) { CLodopJsState = 'complete' }
  head.insertBefore(JS3, head.firstChild)
  head.insertBefore(JS4, head.firstChild)
  CLodopIsLocal = !!((JS1.src + JS2.src + JS3.src + JS4.src).match(/\/\/localho|\/\/127.0.0./i))
}

if (needCLodop()) { loadCLodop() }// 加载

// ==获取LODOP对象主过程,判断是否安装、需否升级:==
export default function getLodop(oOBJECT, oEMBED) {
  const strHtmInstall = "<br><font color='#FF00FF'>打印控件未安装!点击这里<a href='http://www.lodop.net/download.html' target='_blank'>执行安装</a>,安装后请刷新页面或重新进入。</font>"
  const strHtmUpdate = "<br><font color='#FF00FF'>打印控件需要升级!点击这里<a href='http://www.lodop.net/download.html' target='_blank'>执行升级</a>,升级后请重新进入。</font>"
  // eslint-disable-next-line camelcase
  const strHtm64_Install = "<br><font color='#FF00FF'>打印控件未安装!点击这里<a href='http://www.lodop.net/download.html' target='_blank'>执行安装</a>,安装后请刷新页面或重新进入。</font>"
  // eslint-disable-next-line camelcase
  const strHtm64_Update = "<br><font color='#FF00FF'>打印控件需要升级!点击这里<a href='http://www.lodop.net/download.html' target='_blank'>执行升级</a>,升级后请重新进入。</font>"
  const strHtmFireFox = "<br><br><font color='#FF00FF'>（注意：如曾安装过Lodop旧版附件npActiveXPLugin,请在【工具】->【附加组件】->【扩展】中先卸它）</font>"
  const strHtmChrome = "<br><br><font color='#FF00FF'>(如果此前正常，仅因浏览器升级或重安装而出问题，需重新执行以上安装）</font>"
  // eslint-disable-next-line camelcase
  const strCLodopInstall_1 = "<br><font color='#FF00FF'>Web打印服务CLodop未安装启动，点击这里<a href='http://www.lodop.net/download.html' target='_blank'>下载执行安装</a>"
  // eslint-disable-next-line camelcase
  const strCLodopInstall_2 = "<br>（若此前已安装过，可<a href='CLodop.protocol:setup' target='_blank'>点这里直接再次启动</a>）"
  // eslint-disable-next-line camelcase
  const strCLodopInstall_3 = '，成功后请刷新本页面。</font>'
  const strCLodopUpdate = "<br><font color='#FF00FF'>Web打印服务CLodop需升级!点击这里<a href='http://www.lodop.net/download.html' target='_blank'>执行升级</a>,升级后请刷新页面。</font>"
  let LODOP
  try {
    const ua = navigator.userAgent
    const isIE = !!(ua.match(/MSIE/i)) || !!(ua.match(/Trident/i))
    let is64IE
    if (needCLodop()) {
      try {
        // eslint-disable-next-line no-undef
        LODOP = getCLodop()
      // eslint-disable-next-line no-empty
      } catch (err) {}
      if (!LODOP && CLodopJsState !== 'complete') {
        if (CLodopJsState === 'loading') {
          Message.error('网页还没下载完毕，请稍等一下再操作.')
        } else {
          Message.error('没有加载CLodop的主js，请先调用loadCLodop过程.')
        }
        // alert('网页还没下载完毕，请稍等一下再操作.'); else alert('没有加载CLodop的主js，请先调用loadCLodop过程.')
        return
      }
      if (!LODOP) {
        // eslint-disable-next-line camelcase
        // document.body.innerHTML = strCLodopInstall_1 + (CLodopIsLocal ? strCLodopInstall_2 : '') + strCLodopInstall_3 + document.body.innerHTML
        MessageBox({
          title: '提示',
          // eslint-disable-next-line camelcase
          message: strCLodopInstall_1 + (CLodopIsLocal ? strCLodopInstall_2 : '') + strCLodopInstall_3,
          dangerouslyUseHTMLString: true,
          showCancelButton: true,
          confirmButtonText: '刷新',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            location.reload()
          })
          .catch(err => {
            console.log(err)
          })
        return
      } else {
        // eslint-disable-next-line no-undef
        // if (CLODOP.CVERSION < '4.1.1.8') {
        //   // document.body.innerHTML = strCLodopUpdate + document.body.innerHTML
        //   MessageBox({
        //     title: '提示',
        //     // eslint-disable-next-line camelcase
        //     message: strCLodopUpdate,
        //     dangerouslyUseHTMLString: true,
        //     showCancelButton: true,
        //     confirmButtonText: '刷新',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   })
        //     .then(() => {
        //       location.reload()
        //     })
        //     .catch(err => {
        //       console.log(err)
        //     })
        // }
        if (oEMBED && oEMBED.parentNode) { oEMBED.parentNode.removeChild(oEMBED) } // 清理旧版无效元素
        if (oOBJECT && oOBJECT.parentNode) { oOBJECT.parentNode.removeChild(oOBJECT) }
      }
    } else {
      is64IE = isIE && !!(ua.match(/x64/i))
      // ==如果页面有Lodop就直接使用,否则新建:==
      if (oOBJECT || oEMBED) {
        if (isIE) { LODOP = oOBJECT } else { LODOP = oEMBED }
      } else if (!CreatedOKLodopObject) {
        LODOP = document.createElement('object')
        LODOP.setAttribute('width', 0)
        LODOP.setAttribute('height', 0)
        LODOP.setAttribute('style', 'position:absolute;left:0px;top:-100px;width:0px;height:0px;')
        if (isIE) { LODOP.setAttribute('classid', 'clsid:2105C259-1E0C-4534-8141-A753534CB4CA') } else { LODOP.setAttribute('type', 'application/x-print-lodop') }
        document.documentElement.appendChild(LODOP)
        CreatedOKLodopObject = LODOP
      } else { LODOP = CreatedOKLodopObject }
      // ==Lodop插件未安装时提示下载地址:==
      if ((!LODOP) || (!LODOP.VERSION)) {
        let newStr = ''
        if (ua.indexOf('Chrome') >= 0) {
          // document.body.innerHTML = strHtmChrome + document.body.innerHTML
          newStr += strHtmChrome
        }
        if (ua.indexOf('Firefox') >= 0) {
          // document.body.innerHTML = strHtmFireFox + document.body.innerHTML
          newStr += strHtmFireFox
        }
        // eslint-disable-next-line camelcase
        // document.body.innerHTML = (is64IE ? strHtm64_Install : strHtmInstall) + document.body.innerHTML
        MessageBox({
          title: '提示',
          // eslint-disable-next-line camelcase
          message: newStr + (is64IE ? strHtm64_Install : strHtmInstall),
          dangerouslyUseHTMLString: true,
          showCancelButton: true,
          confirmButtonText: '刷新',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            location.reload()
          })
          .catch(err => {
            console.log(err)
          })
        return LODOP
      }
    }
    if (LODOP.VERSION < '6.2.2.6') {
      // eslint-disable-next-line camelcase
      if (!needCLodop()) {
        // document.body.innerHTML = (is64IE ? strHtm64_Update : strHtmUpdate) + document.body.innerHTML
        MessageBox({
          title: '提示',
          // eslint-disable-next-line camelcase
          message: (is64IE ? strHtm64_Update : strHtmUpdate),
          dangerouslyUseHTMLString: true,
          showCancelButton: true,
          confirmButtonText: '刷新',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            location.reload()
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
    // ===如下空白位置适合调用统一功能(如注册语句、语言选择等):==
    LODOP.SET_LICENSES('', 'B5E7121E2D3545605C767E7340CBC94D', '', '')
    // =======================================================
    return LODOP
  } catch (err) {
    Message.error('getLodop出错:' + err)
  }
}

// function createScript(http ,port, priority) {
//   const oscript = document.createElement('script')
//   oscript.src = `${process.env.NODE_ENV === 'development' ? 'http' : 'https'}://localhost:${port}/CLodopfuncs.js?priority=${priority}`
//   const head = document.head || document.getElementsByTagName('head')[0] || document.documentElement
//   head.insertBefore(oscript, head.firstChild)
// }
// createScript(18000, 1)
// createScript(8000, 2)
// // ====获取LODOP对象的主过程：====
// function getLodop(oOBJECT, oEMBED) {
//   const strCLodopInstall = "<br><font color='#FF00FF'>CLodop云打印服务(localhost本地)未安装启动!点击这里<a href='CLodopPrint_Setup_for_Win32NT.exe' target='_self'>执行安装</a>,安装后请刷新页面。</font>"
//   const strCLodopUpdate = "<br><font color='#FF00FF'>CLodop云打印服务需升级!点击这里<a href='CLodopPrint_Setup_for_Win32NT.exe' target='_self'>执行升级</a>,升级后请刷新页面。</font>"
//   let LODOP
//   try {
//     const isIE = (navigator.userAgent.indexOf('MSIE') >= 0) || (navigator.userAgent.indexOf('Trident') >= 0)

//     try {
//       // eslint-disable-next-line no-undef
//       LODOP = getCLodop()
//     } catch (err) {
//       console.log(err)
//     }
//     if (!LODOP && document.readyState !== 'complete') {
//       Message.error('C-Lodop没准备好，请稍后再试！')
//       return
//     }
//     if (!LODOP) {
//       if (isIE) {
//         // document.write(strCLodopInstall)
//         // Message.error(strCLodopInstall)
//         MessageBox({
//           title: '提示',
//           message: 'CLodop云打印服务(本地)未安装启动,请先启用服务或点击确定立即安装。',
//           showCancelButton: true,
//           confirmButtonText: '确定',
//           cancelButtonText: '取消',
//           type: 'warning'
//         })
//           .then(() => {
//             window.open('http://www.lodop.net/download.html')
//           })
//           .catch(err => {
//             console.log(err)
//           })
//       } else {
//         // document.documentElement.innerHTML = strCLodopInstall + document.documentElement.innerHTML
//         // Message.error(strCLodopInstall)
//         MessageBox({
//           title: '提示',
//           message: 'CLodop云打印服务(本地)未安装启动,请先启用服务或点击确定立即安装。',
//           showCancelButton: true,
//           confirmButtonText: '确定',
//           cancelButtonText: '取消',
//           type: 'warning'
//         })
//           .then(() => {
//             window.open('http://www.lodop.net/download.html')
//           })
//           .catch(err => {
//             console.log(err)
//           })
//       }
//       return
//     } else {
//       // eslint-disable-next-line no-undef
//       if (CLODOP.CVERSION < '2.0.8.0') {
//         if (isIE) {
//         //   document.write(strCLodopUpdate)
//           // Message.error(strCLodopUpdate)
//           MessageBox({
//             title: '提示',
//             message: 'CLodop云打印服务需升级,点击确定立即升级。',
//             showCancelButton: true,
//             confirmButtonText: '确定',
//             cancelButtonText: '取消',
//             type: 'warning'
//           })
//             .then(() => {
//               window.open('http://www.lodop.net/download.html')
//             })
//             .catch(err => {
//               console.log(err)
//             })
//         } else {
//         //   document.documentElement.innerHTML = strCLodopUpdate + document.documentElement.innerHTML
//           // Message.error(strCLodopUpdate)
//           MessageBox({
//             title: '提示',
//             message: 'CLodop云打印服务需升级,点击确定立即升级。',
//             showCancelButton: true,
//             confirmButtonText: '确定',
//             cancelButtonText: '取消',
//             type: 'warning'
//           })
//             .then(() => {
//               window.open('http://www.lodop.net/download.html')
//             })
//             .catch(err => {
//               console.log(err)
//             })
//         }
//       }
//       if (oEMBED && oEMBED.parentNode) oEMBED.parentNode.removeChild(oEMBED)
//       if (oOBJECT && oOBJECT.parentNode) oOBJECT.parentNode.removeChild(oOBJECT)
//     }
//     LODOP.SET_LICENSES('', 'B5E7121E2D3545605C767E7340CBC94D', '', '')
//     return LODOP
//   } catch (err) {
//     Message.error('getLodop出错:' + err)
//     // alert('getLodop出错:' + err)
//   }
// }

// function needCLodop() {
//   return true
// }

// export default getLodop
